import { Stack } from "@fluentui/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { queryPlannerItemsAsync } from "src/api/plannerApi";
import { localize } from "src/l10n";
import { SpintrTypes } from "src/typings";
import { Label, UnstyledButton } from "src/ui";
import "./QuinyxLoader.scss";
import CountdownChart from "src/components/Planner/TimelineAgenda/CountdownChart";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { Link } from "react-router-dom";

const QuinyxLoader = () => {
    const [item, setItem] = useState<Spintr.PlannerItem>();

    useEffect(() => {
        queryPlannerItemsAsync({
            after: new Date(),
            take: 1,
            status: SpintrTypes.ContentStatus.Published,
            itemType: SpintrTypes.PlannerItemType.WorkShift,
        }).then((data) => {
            if (data.items.length === 0) {
                return;
            }

            setItem(data.items[0]);
        });
    }, []);

    if (item == null) {
        return null;
    }

    const isOngoing = item.startsAt < new Date();

    return (
        <div className="QuinyxLoader">
            <div className="teaser-box-container">
                <div className="teaser-box-wrapper">
                    <div className="teaser-box">
                        <div className="start-page-flexible-padding">
                            <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
                                <Stack horizontal tokens={{ childrenGap: 12 }} verticalAlign="center">
                                    {isOngoing ? (
                                        <CountdownChart item={item} />
                                    ) : (
                                        <Stack className="date-circle" verticalAlign="center" horizontalAlign="center">
                                            <Label size="body-2">{moment(item.startsAt).format("MMM")}</Label>
                                            <Label size="body-2">{moment(item.startsAt).format("DD")}</Label>
                                        </Stack>
                                    )}

                                    <div>
                                        <Label weight="medium">
                                            {localize(isOngoing ? "ONGOING_WORKSHIFT" : "NEXT_WORKSHIFT")}
                                        </Label>
                                        <Label>
                                            {moment(item.startsAt).format("LT")} - {moment(item.endsAt).format("LT")}
                                        </Label>
                                    </div>
                                </Stack>
                                <Link to="/timeline/agenda">
                                    <UnstyledButton>
                                        <Visage2Icon icon="arrow-right-3" />
                                    </UnstyledButton>
                                </Link>
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuinyxLoader;
